import React from 'react';
import { differentiators } from '../data/product';
export function DifferentiatorSection() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-30" data-mp="3j4h21t7l4h6y">
      <div className="mx-auto max-w-4xl" data-id="element-31" data-mp="3j24i5ai9nwr9">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-32" data-mp="3558yyp8awoxh">
          THIS ISN’T JUST ANOTHER MAINTENANCE EBOOK
        </h2>
        <p className="mt-0.5 text-center font-head text-base font-bold uppercase tracking-wide text-volt sm:text-xl" data-id="element-33" data-mp="3a1pp1oz29dd7">
          IT’S A READY-TO-USE TROUBLESHOOTING SYSTEM.
        </p>

        <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-34" data-mp="306xme6qmg0bk">
          {differentiators.map(item => <li key={item.title} className="rounded-md border-l-4 border-volt bg-white p-2.5 shadow-sm" data-id="element-35" data-mp="2mfswhwd22mef">
              <p className="font-head text-[14px] font-bold uppercase tracking-wide text-navy sm:text-base" data-id="element-36" data-mp="2cg1xpihgpl8j">
                <span aria-hidden="true" data-id="element-37" data-mp="2hfep8gja3ghg">{item.icon}</span> {item.title}
              </p>
              <p className="mt-0.5 text-[13px] font-medium leading-snug text-carbon/80" data-id="element-38" data-mp="15gvzquhcfb29">
                {item.body}
              </p>
            </li>)}
        </ul>

        <p className="mt-2 text-center font-head text-base font-bold uppercase tracking-[0.12em] text-navy sm:text-lg" data-id="element-39" data-mp="10kdsnnyjj0mr">
          Less searching. Less guessing. More structure.
        </p>
      </div>
    </section>;
}